import { Img } from '@qonsoll/react-design'
// import logoQonsoll from 'assets/logo-ql-full-primary.svg'
import logoTips from 'assets/TipsLogo.png'

const Logo = () => {
  return <Img src={logoTips} alt="Qonsoll" height="40" width="40" />
}

export default Logo
